<template>
  <div class="gx-roles">
    <div class="gx-roles__head">
      <!-- <h1 class="gx-main__title">岗位管理</h1> -->
    </div>

    <!-- 查询栏 -->
    <div class="gx-roles__filter">
      <input v-model="searchData.name" class="gx-roles__input" placeholder="搜索岗位名称" @keyup.enter="getList(true)" />
      <select v-model="searchData.status" class="gx-roles__select">
        <option value="">全部状态</option>
        <option value="1">启用</option>
        <option value="2">禁用</option>
      </select>
      <button class="gx-roles__btn gx-roles__btn--primary" @click="getList(true)">查询</button>
      <button class="gx-roles__btn" @click="resetSearch">重置</button>
      <div class="gx-roles__spacer"></div>
      <button class="gx-roles__btn gx-roles__btn--add" @click="positionOpen('1')">
        <svg width="11" height="11" viewBox="0 0 11 11" fill="none"><path d="M5.5 1v9M1 5.5h9" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" /></svg>
        新增岗位
      </button>
      <button class="gx-roles__btn gx-roles__btn--danger" :disabled="!ids.length" @click="positionDel(null)">
        删除
      </button>
    </div>

    <!-- 表格 -->
    <div class="gx-roles__card">
      <div class="gx-roles__table">
        <table>
          <thead>
            <tr>
              <th style="width: 36px">
                <span
                  class="gx-roles__checkbox"
                  :class="{ 'gx-roles__checkbox--on': allChecked }"
                  @click="toggleAll"
                >
                  <svg v-if="allChecked" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
                </span>
              </th>
              <th>岗位名称</th>
              <th>岗位描述</th>
              <th>状态</th>
              <th style="width: 160px">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, i) in list" :key="row.role_id">
              <td>
                <span
                  class="gx-roles__checkbox"
                  :class="{ 'gx-roles__checkbox--on': ids.includes(row.role_id) }"
                  @click="toggleOne(row.role_id)"
                >
                  <svg v-if="ids.includes(row.role_id)" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
                </span>
              </td>
              <td class="gx-roles__td-name">{{ row.name }}</td>
              <td class="gx-roles__td-desc">{{ row.description }}</td>
              <td>
                <span class="gx-roles__status" :class="row.status == 1 ? 'gx-roles__status--on' : 'gx-roles__status--off'">
                  <span class="gx-roles__status-dot"></span>{{ row.status == 1 ? '启用' : '禁用' }}
                </span>
              </td>
              <td>
                <div class="gx-roles__ops">
                  <button class="gx-roles__op gx-roles__op--edit" @click="positionOpen('2', row.role_id)">修改</button>
                  <button class="gx-roles__op gx-roles__op--del" @click="positionDel(row)">删除</button>
                </div>
              </td>
            </tr>
            <tr v-if="!list.length">
              <td :colspan="5" class="gx-roles__empty">
                <div class="gx-roles__empty-box">
                  <div class="gx-roles__empty-icon">
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                      <rect x="5" y="8" width="18" height="14" rx="2" stroke="#C8443C" stroke-width="1.6" />
                      <path d="M9 8V7a5 5 0 0110 0v1" stroke="#C8443C" stroke-width="1.6" stroke-linecap="round" />
                      <path d="M14 13v6M11 16h6" stroke="#C8443C" stroke-width="1.6" stroke-linecap="round" />
                    </svg>
                  </div>
                  <div class="gx-roles__empty-title">暂无岗位数据</div>
                  <div class="gx-roles__empty-sub">点击「新增岗位」，为平台新增岗位与配置权限</div>
                  <button class="gx-roles__btn gx-roles__btn--add" @click="positionOpen('1')">新增岗位</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- <div class="gx-roles__pager">
        <div class="gx-roles__pager-left">
          <span class="gx-roles__pager-total">共 {{ pageData.total }} 条</span>
          <page-size-select :value="pageData.limit" :options="pageSizeOptions" @change="onPageSizeChange" />
        </div>
        <div class="gx-roles__pager-btns">
          <button class="gx-roles__page" :disabled="pageData.page <= 1" @click="getList(true, pageData.page - 1)">上一页</button>
          <button v-for="n in pageNums" :key="n" class="gx-roles__page" :class="{ 'gx-roles__page--on': n === pageData.page }" @click="getList(true, n)">{{ n }}</button>
          <button class="gx-roles__page" :disabled="pageData.page >= totalPages" @click="getList(true, pageData.page + 1)">下一页</button>
        </div>
      </div> -->
      <div style="padding: 10px 14px;background: rgb(245, 240, 232);">
        <Pagination :total="pageData.total" :page.sync="pageData.page" :limit.sync="pageData.limit" :page-sizes="[10, 20, 50, 100,  200, 300, 400]" @pagination="getList(true,pageData.page)"  layout="total, sizes, prev, pager, next, jumper" />
      </div>
    </div>

    <!-- 岗位弹窗 -->
    <div v-if="positionData.isShow" class="gx-roles__modal" @click.self="closeMask">
      <div class="gx-roles__modal-box">
        <div class="gx-roles__modal-head">
          <div class="gx-roles__modal-title-wrap">
            <span class="gx-roles__modal-bar"></span>
            <span class="gx-roles__modal-title">{{ positionData.title }}</span>
          </div>
          <button class="gx-roles__modal-close" @click="closeMask">
            <svg width="11" height="11" viewBox="0 0 11 11" fill="none"><path d="M1 1l9 9M10 1L1 10" stroke="#4A4A6A" stroke-width="1.4" stroke-linecap="round" /></svg>
          </button>
        </div>
        <div class="gx-roles__modal-body">
          <div class="gx-roles__form-row">
            <div class="gx-roles__field">
              <label class="gx-roles__field-label"><span class="gx-roles__req">*</span>岗位名称</label>
              <input v-model="positionData.data.name" class="gx-roles__field-input" placeholder="请输入岗位名称" />
            </div>
            <div class="gx-roles__field">
              <label class="gx-roles__field-label">岗位描述</label>
              <input v-model="positionData.data.description" class="gx-roles__field-input" placeholder="请输入岗位描述（选填）" />
            </div>
          </div>
          <div class="gx-roles__field">
            <label class="gx-roles__field-label">岗位状态</label>
            <div class="gx-roles__status-group">
              <div
                class="gx-roles__status-item"
                :class="{ 'is-active': positionData.data.status == 1 }"
                @click="positionData.data.status = '1'"
              >
                <span class="gx-roles__status-radio"></span>
                <span>启用</span>
              </div>
              <div
                class="gx-roles__status-item"
                :class="{ 'is-active': positionData.data.status == 2 }"
                @click="positionData.data.status = '2'"
              >
                <span class="gx-roles__status-radio"></span>
                <span>禁用</span>
              </div>
            </div>
          </div>
          <div class="gx-roles__field">
            <label class="gx-roles__field-label">店铺分组</label>
            <div class="gx-roles__group-tags">
              <label v-for="g in groupList" :key="g.id" class="gx-roles__group-tag" :class="{ 'is-checked': (positionData.data.groupids || []).indexOf(g.id) > -1 }">
                <input type="checkbox" :value="g.id" v-model="positionData.data.groupids" />
                <span>{{ g.name }}</span>
              </label>
            </div>
          </div>
          <div class="gx-roles__field">
            <label class="gx-roles__field-label"><span class="gx-roles__req">*</span>菜单权限</label>
            <div class="gx-roles__tree">
              <el-tree
                ref="tree"
                :data="sysList"
                show-checkbox
                node-key="menu_id"
                :props="treeProps"
                default-expand-all
                :check-strictly="false"
                @check="handleCheckChange"
              ></el-tree>
            </div>
          </div>
        </div>
        <div class="gx-roles__modal-foot">
          <button class="gx-roles__modal-btn" @click="closeMask">取消</button>
          <button class="gx-roles__modal-btn gx-roles__modal-btn--primary" :disabled="saving" @click="saveEdit">
            {{ saving ? '保存中...' : '保存岗位' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import PageSizeSelect from '../../components/newUi/PageSizeSelect.vue'
import { getPermissionTree } from '../../config/newUiPermissions'
import Pagination from '../../components/newUi/Pagination.vue'

export default {
  name: 'NewRolesPage',
  components: { PageSizeSelect,Pagination },  
  data() {
    return {
      searchData: { status: '' },
      pageData: { limit: 10, page: 1, total: 0 },
      pageSizeOptions: [10, 20, 50, 100, 200],
      list: [],
      ids: [],
      sysList: [],
      groupList: [],
      treeProps: { label: 'title', children: 'children' },
      positionData: {
        isShow: false,
        title: '新增岗位',
        openType: '1',
        role_id: '',
        data: { name: '', groupids: [], status: '1', description: '', new_ui_access: [] }
      },
      saving: false
    }
  },
  computed: {
    totalPages() {
      return Math.max(1, Math.ceil(this.pageData.total / this.pageData.limit))
    },
    pageNums() {
      const total = this.totalPages
      const nums = []
      const start = Math.max(1, Math.min(this.pageData.page - 2, total - 4))
      for (let i = start; i <= Math.min(total, start + 4); i++) nums.push(i)
      return nums.length ? nums : [1]
    },
    allChecked() {
      return this.list.length > 0 && this.ids.length === this.list.length
    }
  },
  created() {
    this.sysList = getPermissionTree()
    this.getList(true)
    this.getShopBoardGroupList({
      data: {},
      success: (res) => {
        if (res.code === 200) this.groupList = res.data || []
      }
    })
  },
  methods: {
    ...mapActions({
      getBusinessRoleIndex: 'ucenter/getBusinessRoleIndex',
      getBusinessRoleInfo: 'ucenter/getBusinessRoleInfo',
      opBusinessRoleAdd: 'ucenter/opBusinessRoleAdd',
      opBusinessRoleUpdate: 'ucenter/opBusinessRoleUpdate',
      opBusinessRoleDel: 'ucenter/opBusinessRoleDel',
      getShopBoardGroupList: 'shop_board/getShopBoardGroupList'
    }),
    onPageSizeChange(size) {
      this.pageData.limit = size
      this.pageData.page = 1
      this.getList(true, 1)
    },
    getList(showLoading, page) {
      if (page) this.pageData.page = page
      const param = { limit: this.pageData.limit, page: this.pageData.page }
      Object.assign(param, this.searchData)
      this.getBusinessRoleIndex({
        data: param,
        success: (res) => {
          if (res.code === 200) {
            this.list = res.data.list
            this.pageData.total = res.data.total
            this.ids = []
          } else {
            this.$message({ message: res.msg, type: 'error' })
          }
        }
      })
    },
    resetSearch() {
      this.searchData = { status: '' }
      this.pageData.page = 1
      this.getList(true)
    },
    positionOpen(type, id) {
      this.positionData.isShow = true
      this.positionData.openType = type
      this.positionData.data.new_ui_access = []
      this.positionData.data.groupids = []
      this.positionData.data.description = ''
      this.positionData.data.name = ''
      this.positionData.data.status = '1'
      if (type === '1') {
        this.positionData.title = '新增岗位'
        this.positionData.role_id = ''
      } else {
        this.positionData.title = '修改岗位'
        this.positionData.role_id = id
        this.getBusinessRoleInfo({
          data: { role_id: id },
          success: (res) => {
            if (res.code === 200) {
              this.positionData.data = Object.assign(this.positionData.data, res.data)
              const arr = res.data.new_ui_access ? String(res.data.new_ui_access).split(',') : []
              this.$nextTick(() => {
                this.$refs.tree.setCheckedKeys(arr)
              })
            } else {
              this.$message({ message: res.msg, type: 'error' })
            }
          }
        })
      }
    },
    positionDel(row) {
      let ids = row ? row.role_id : this.ids.join(',')
      if (!ids) {
        this.$message.warning('请先勾选要删除的岗位')
        return
      }
      this.$confirm('确定删除选中的岗位吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.opBusinessRoleDel({
          data: { role_id: ids },
          success: (res) => {
            if (res.code === 200) {
              this.$message.success(res.msg || '删除成功')
              this.ids = []
              this.getList(true)
            } else {
              this.$message.error(res.msg)
            }
          }
        })
      }).catch(() => {})
    },
    toggleOne(id) {
      const idx = this.ids.indexOf(id)
      if (idx > -1) this.ids.splice(idx, 1)
      else this.ids.push(id)
    },
    toggleAll() {
      if (this.allChecked) this.ids = []
      else this.ids = this.list.map((r) => r.role_id)
    },
    handleCheckChange() {
      this.positionData.data.new_ui_access = this.$refs.tree.getCheckedKeys(true)
    },
    closeMask() {
      this.positionData.isShow = false
    },
    saveEdit() {
      if (!this.positionData.data.name) {
        this.$message.info('请输入岗位名称！')
        return
      }
      const keys = this.$refs.tree.getCheckedKeys(true)
      if (!keys.length) {
        this.$message.info('请至少勾选一项菜单权限！')
        return
      }
      this.saving = true
      const param = {
        name: this.positionData.data.name,
        description: this.positionData.data.description || '',
        groupids: this.positionData.data.groupids || [],
        status: this.positionData.data.status || '1',
        new_ui_access: keys.join(',')
      }
      if (this.positionData.openType === '1') {
        this.opBusinessRoleAdd({
          data: param,
          success: (res) => {
            this.saving = false
            if (res.code === 200) {
              this.$message.success(res.msg || '新增成功')
              this.closeMask()
              this.pageData.page = 1
              this.getList(true)
            } else {
              this.$message.error(res.msg)
            }
          }
        })
      } else {
        param.role_id = this.positionData.role_id
        this.opBusinessRoleUpdate({
          data: param,
          success: (res) => {
            this.saving = false
            if (res.code === 200) {
              this.$message.success(res.msg || '修改成功')
              this.closeMask()
              this.getList(true)
            } else {
              this.$message.error(res.msg)
            }
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.gx-roles__filter {
/*  border-radius: 12px;
  padding: 12px 14px;
  margin-bottom: 16px;
  background: #FFFFFF;
  border: 1px solid #E1E5EE;
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;*/
  background: rgb(255, 255, 255);
  border-radius: 8px;
  border: 2px solid rgb(224, 224, 236);
  padding: 10px 14px;
  margin-bottom: 14px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 4px;
}
.gx-roles__input {
  width: 180px;
  height: 28px;
  padding: 0 10px;
  border-radius: 4px;
  border: 1px solid #E0E0EC;
  font-size: 12px;
  color: #1A1A2E;
  outline: none;
  box-sizing: border-box;
  transition: border .15s;
}
.gx-roles__input:focus {
  border-color: #C8443C;
  box-shadow: 0 0 0 2px #FFF5F5;
}
.gx-roles__select {
  height: 28px;
  padding: 0 8px;
  border-radius: 4px;
  border: 1px solid #E0E0EC;
  background: #FFFFFF;
  font-size: 12px;
  color: #1A1A2E;
  outline: none;
  min-width: 110px;
}
.gx-roles__select:focus {
  border-color: #C8443C;
}
.gx-roles__spacer {
  flex: 1;
}
.gx-roles__btn {
  height: 30px;
  padding: 0 14px;
  border-radius: 7px;
  cursor: pointer;
  background: #FFFFFF;
  border: 1px solid #E0E0EC;
  font-size: 13px;
  color: #4A4A6A;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  transition: all .16s;
}
.gx-roles__btn:hover:not(:disabled) {
  border-color: #C8443C;
  color: #C8443C;
}
.gx-roles__btn--primary {
  background: #C8443C;
  border-color: #C8443C;
  font-weight: 600;
  color: #fff;
}
.gx-roles__btn--primary:hover:not(:disabled) {
  background: #B83A33;
  border-color: #B83A33;
  color: #fff;
}
.gx-roles__btn--add {
  background: #C8443C;
  border-color: #C8443C;
  font-weight: 600;
  color: #fff;
}
.gx-roles__btn--add:hover:not(:disabled) {
  background: #B83A33;
  border-color: #B83A33;
  color: #fff;
}
.gx-roles__btn--danger {
  color: #C8443C;
  border-color: #F2C6C3;
  background: #FFF7F7;
}
.gx-roles__btn--danger:hover:not(:disabled) {
  color: #B83A33;
  border-color: #C8443C;
  background: #FFF0F0;
}
.gx-roles__btn:disabled {
  opacity: .5;
  cursor: not-allowed;
}
.gx-roles__card {
  border-radius: 12px;
  border: 1px solid #E1E5EE;
  margin-bottom: 16px;
  background: #FFFFFF;
  overflow: visible;
}
.gx-roles__table {
  border-radius: 12px 12px 0 0;
  overflow: hidden;
  background: #FFFFFF;
}
.gx-roles__table table {
  width: 100%;
  border-collapse: collapse;
}
.gx-roles__table th {
  padding: 11px 14px;
  text-align: left;
  background: #F5F0E8;
  font-size: 12px;
  font-weight: 500;
  color: #4A4A6A;
  letter-spacing: .02em;
}
.gx-roles__table td {
  padding: 12px 14px;
  font-size: 13px;
  color: #1A1A2E;
  border-top: 1px solid #F0F0F4;
}
.gx-roles__td-name {
  font-weight: 500;
}
.gx-roles__td-desc {
  color: #4A4A6A;
}
.gx-roles__checkbox {
  width: 15px;
  height: 15px;
  border-radius: 4px;
  background: #FFFFFF;
  border: 1.5px solid #D0D0DD;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  vertical-align: middle;
}
.gx-roles__checkbox--on {
  background: #C8443C;
  border-color: #C8443C;
}
.gx-roles__status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 9px;
  border-radius: 5px;
  font-size: 11px;
  font-weight: 500;
}
.gx-roles__status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}
.gx-roles__status--on {
  background: rgba(74, 222, 128, .1);
  border: 1px solid rgba(74, 222, 128, .3);
  color: #16A34A;
}
.gx-roles__status--on .gx-roles__status-dot {
  background: #22C55E;
}
.gx-roles__status--off {
  background: rgba(139, 157, 195, .1);
  border: 1px solid rgba(139, 157, 195, .3);
  color: #6A6A8A;
}
.gx-roles__status--off .gx-roles__status-dot {
  background: #6A6A8A;
}
.gx-roles__ops {
  display: flex;
  gap: 6px;
}
.gx-roles__op {
  height: 26px;
  padding: 0 10px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 11px;
  border: 1px solid;
  transition: all .16s;
}
.gx-roles__op--edit {
  background: #E6F4FF;
  border-color: #91CAFF;
  color: #1677FF;
}
.gx-roles__op--edit:hover {
  background: #1677FF;
  color: #fff;
}
.gx-roles__op--del {
  background: #FFF5F5;
  border-color: #FFCCC7;
  color: #C8443C;
}
.gx-roles__op--del:hover {
  background: #C8443C;
  color: #fff;
}
.gx-roles__empty {
  text-align: center;
  padding: 48px 0 !important;
}
.gx-roles__empty-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
}
.gx-roles__empty-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #FFF5F5;
  border: 1px solid #FFCCC7;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
}
.gx-roles__empty-title {
  font-size: 14px;
  font-weight: 500;
  color: #1A1A2E;
  margin-bottom: 6px;
}
.gx-roles__empty-sub {
  font-size: 12px;
  color: rgba(200, 68, 60, .68);
  line-height: 1.7;
  margin-bottom: 16px;
}
.gx-roles__pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 10px 14px;
  border-top: 1px solid #E0E0EC;
  background: #F5F0E8;
  border-radius: 0 0 12px 12px;
  position: relative;
  z-index: 5;
}
.gx-roles__pager-left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.gx-roles__pager-total {
  font-size: 12px;
  color: #6A6A8A;
}
.gx-roles__pager-btns {
  display: flex;
  gap: 5px;
}
.gx-roles__page {
  min-width: 30px;
  height: 30px;
  padding: 0 8px;
  border-radius: 6px;
  border: 1px solid #E1E5EE;
  background: #FFFFFF;
  cursor: pointer;
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  color: #4A4A6A;
}
.gx-roles__page:disabled {
  opacity: .5;
  cursor: not-allowed;
}
.gx-roles__page--on {
  background: #C8443C;
  border-color: #C8443C;
  color: #fff;
  font-weight: 700;
}
.gx-roles__modal {
  position: fixed;
  inset: 0;
  z-index: 700;
  background: rgba(8, 14, 36, .55);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.gx-roles__modal-box {
  width: 100%;
  max-width: 960px;
  max-height: 90vh;
  overflow: auto;
  border-radius: 12px;
  background: #F5F0E8;
  border: 1px solid #E0E0EC;
  box-shadow: 0 12px 48px rgba(0, 0, 0, .18);
}
.gx-roles__modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px 20px;
  border-bottom: 1px solid #E0E0EC;
  position: sticky;
  top: 0;
  background: #F5F0E8;
  z-index: 1;
}
.gx-roles__modal-title-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
}
.gx-roles__modal-bar {
  width: 3px;
  height: 15px;
  border-radius: 2px;
  background: #C8443C;
}
.gx-roles__modal-title {
  font-family: 'Noto Serif SC', serif;
  font-size: 15px;
  font-weight: 600;
  color: #1A1A2E;
}
.gx-roles__modal-close {
  width: 26px;
  height: 26px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 1px solid #E0E0EC;
  cursor: pointer;
  padding: 0;
}
.gx-roles__modal-close:hover {
  background: #FFF5F5;
}
.gx-roles__modal-body {
  padding: 18px 20px;
  background: #FFFFFF;
}
.gx-roles__form-row {
  display: flex;
  gap: 24px;
}
.gx-roles__form-row .gx-roles__field {
  flex: 1;
  min-width: 0;
}
.gx-roles__field {
  margin-bottom: 14px;
}
.gx-roles__field-label {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #4A4A6A;
  margin-bottom: 8px;
}
.gx-roles__req {
  color: #C8443C;
}
.gx-roles__field-input {
  width: 100%;
  height: 36px;
  padding: 0 12px;
  border-radius: 6px;
  border: 1px solid #E0E0EC;
  background: #fff;
  font-size: 13px;
  color: #1A1A2E;
  outline: none;
  box-sizing: border-box;
  transition: border .15s;
}
.gx-roles__field-input:focus {
  border-color: #C8443C;
  box-shadow: 0 0 0 2px #FFF5F5;
}
.gx-roles__status-group {
  display: flex;
  gap: 10px;
}
.gx-roles__status-item {
  min-width: 132px;
  height: 42px;
  padding: 0 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px solid #E0E0EC;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  color: #6A6A8A;
  transition: all .15s;
  background: #fff;
  user-select: none;
}
.gx-roles__status-item:hover {
  border-color: #FFCCC7;
}
.gx-roles__status-item.is-active {
  border-color: #C8443C;
  border-width: 1.5px;
  background: #FFF7F7;
  color: #C8443C;
  font-weight: 500;
}
.gx-roles__status-radio {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 1.5px solid #D0D0DD;
  position: relative;
  flex-shrink: 0;
  transition: all .15s;
}
.gx-roles__status-item.is-active .gx-roles__status-radio {
  border-color: #C8443C;
}
.gx-roles__status-item.is-active .gx-roles__status-radio::after {
  content: '';
  position: absolute;
  inset: 2px;
  border-radius: 50%;
  background: #C8443C;
}
.gx-roles__group-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.gx-roles__group-tag {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  border-radius: 6px;
  border: 1px solid #E0E0EC;
  cursor: pointer;
  font-size: 12px;
  color: #4A4A6A;
  background: #fff;
  transition: all .15s;
}
.gx-roles__group-tag input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.gx-roles__group-tag.is-checked {
  border-color: #C8443C;
  background: #FFF5F5;
  color: #C8443C;
}
.gx-roles__tree {
  border: 1px solid #E1E5EE;
  border-radius: 8px;
  padding: 10px;
  max-height: 240px;
  overflow: auto;
  background: #fff;
}
.gx-roles__modal-foot {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 20px;
  border-top: 1px solid #E0E0EC;
  position: sticky;
  bottom: 0;
  background: #F5F0E8;
}
.gx-roles__modal-btn {
  height: 32px;
  padding: 0 16px;
  border-radius: 5px;
  cursor: pointer;
  background: #fff;
  border: 1px solid #E0E0EC;
  font-size: 13px;
  color: #4A4A6A;
  transition: all .15s;
}
.gx-roles__modal-btn:hover:not(:disabled) {
  border-color: #C8443C;
  color: #C8443C;
}
.gx-roles__modal-btn--primary {
  background: linear-gradient(135deg, #EC8F8A, #F3ACA8);
  border: none;
  font-weight: 600;
  color: #fff;
}
.gx-roles__modal-btn--primary:hover:not(:disabled) {
  color: #fff;
  opacity: .92;
}
.gx-roles__modal-btn--primary:disabled {
  background: #f0f0f0;
  color: #6A6A8A;
  opacity: .6;
  cursor: not-allowed;
}
</style>
